import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/ReduxProvider/store';

export const getSettings = createSelector(
  (state: RootStateType) => state.settings,
  (settings) => settings,
);
